/*
 * クライアント側(ログイン等)認証用JavaScript
 * 参照元：http://ghe.aws01.mapion.co.jp/mapiondev/contents/blob/master/mapion_smartphone/js/common/authn_api.js
 */
var AuthN = function(){
  var {$, location}= window;
	var url = '';
	var client_id = (location.hostname==="www.mapion.co.jp" ? "e097821ab94385cb43363b9b914608cf" : "5335b8b3241f9585e625b70556e8a36a" );
	var access_token = null;

	function setUrl(baseUrl) {
		if (!/^https?:\/\/([a-zA-Z0-9_-]+\.)*mapion\.co\.jp\//.test(baseUrl)) {
			throw new Error('Invalid Base Url');
		}
		url = baseUrl;
	}

  function getMsessionId() {
    let msessionID = null;
    let msessionIDcookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('MSESSIONID='));
    if (msessionIDcookie && msessionIDcookie.split('=')[1]) {
      msessionID = msessionIDcookie.split('=')[1];
    }
    return msessionID;
  }

	
	function refreshToken(error) {
		if (!getMsessionId()) return;
		$.ajax({
			type        : 'POST',
			url         : url + "/token",
			headers     : {'Authorization' : 'Msessionid id=' + getMsessionId() + ' client_id=' + client_id, 'Access-Control-Request-Headers' : 'Authorization'},
			data        : {request_type : 'token'},
			dataType    : 'text',
			cache       : false,
			async       : false,
			success     : function(text){
				access_token = text;
			},
			error       : function(XMLHttpRequest, textStatus, errorThrown){
				error && error(errorThrown);
			}
		});
	}

	function login(param, success, error) {
		$.ajax({
			type        : 'POST',
			url         : url + "/sessions",
			headers     : {'client-id' : client_id, 'Access-Control-Request-Headers' : 'Authorization'},
			data        : {mapionid : param.id, password : param.pw},
			dataType    : 'text',
			cache       : false,
			async       : false,
			success     : function(text){
				// $.cookie("MSESSIONID", text, { domain: '.mapion.co.jp', path: '/' });
        document.cookie = "MSESSIONID=" + text + "; domain=.mapion.co.jp; path=/";
				success && success();
			},
			error       : function(XMLHttpRequest, textStatus, errorThrown){
				error && error(errorThrown);
			}
		});
	}

	function getAccessToken() {
		return access_token;
	}

	return {
		setUrl : setUrl,
		refreshToken : refreshToken,
		login : login,
		getAccessToken : getAccessToken
	};
}();

export default AuthN;